import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ShowAllProducts.css';
import { API_BASE } from '../api';
import { useCart } from '../context/CartContext';

const ShowAllProducts = () => {
    const { addToCart } = useCart();
    const [product, setProduct] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [justAddedToCartId, setJustAddedToCartId] = useState(null);

    function getAllProducts() {
        setLoading(true);
        setError(null);
        fetch(API_BASE + '/')
            .then((response) => {
                if (!response.ok) throw new Error('Failed to load products');
                return response.json();
            })
            .then((data) => {
                setProduct(Array.isArray(data) ? data : []);
            })
            .catch((err) => {
                console.error('Error fetching products:', err);
                setError(err.message || 'Could not load products. The backend may be starting up (free tier takes ~30s). Try refreshing.');
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        getAllProducts();
    }, []);

    const filteredProducts = product.filter((el) =>
        el.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const showAllItems = (searchTerm ? filteredProducts : product).map((el) => {
        const stars = [];
        const ratingRate = el.rating?.rate ?? 0;
        for (let i = 1; i <= ratingRate; i++) {
            stars.push(<span key={i} className="active"></span>);
        }

        return (
            <div key={el._id} className="col-md-3 col-sm-6 mb-4">
                <Link to={`/product/${el._id}`} className="product-card-link">
                    <div className="card h-100">
                        <img
                            src={el.image || `https://picsum.photos/seed/${el._id}/400/400`}
                            className="card-img-top"
                            alt={el.title}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `https://picsum.photos/seed/${el._id}/400/400`;
                            }}
                        />
                        <div className="card-body">
                            <h5 className="card-title">{el.title}</h5>
                            <p className="card-text">Category: {el.category}</p>
                            <p className="card-text product-price">
                                Price: ${Number(el.price).toFixed(2)}
                            </p>
                            <div className="rating-stars">
                                {stars}
                                <span>({el.rating?.count ?? 0})</span>
                            </div>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm mt-2"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    addToCart(el);
                                    setJustAddedToCartId(el._id);
                                    window.setTimeout(() => setJustAddedToCartId((cur) => (cur === el._id ? null : cur)), 1500);
                                }}
                            >
                                {justAddedToCartId === el._id ? 'Added!' : 'Add to Cart'}
                            </button>
                        </div>
                    </div>
                </Link>
            </div>
        );
    });

    return (
        <div className="show-all-products-container">
            <header className="shop-page-header">
                <h1 className="shop-page-title">Shop the collection</h1>
                <p className="shop-page-subtitle">Browse styles, read reviews, and add favorites to your cart.</p>
            </header>
            {loading && <p>Loading products...</p>}
            {error && (
                <div style={{ color: 'red', marginBottom: '1rem' }}>
                    {error}
                    <button onClick={getAllProducts} style={{ marginLeft: '0.5rem' }}>Retry</button>
                </div>
            )}
            <input
                type="text"
                placeholder="Search products..."
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <hr />
            {!loading && !error && (
                <div className="container">
                    <div className="row">{showAllItems}</div>
                </div>
            )}
            <hr />
            <footer className="footer">
                <div className="container">
                    <p className="text-muted">© All rights reserved by Rishi.</p>
                </div>
            </footer>
        </div>
    );

};

export default ShowAllProducts;





